import { BrButton } from '@govbr-ds/react-components';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';
import React, { ReactNode } from 'react';
import { incluirSentryIdMsgErro } from 'utils/incluirSentryIdMsgErro';
import unhappyFace from '../../assets/unhappy-face.png';
import styles from './errorMessage.module.scss';

interface ErrorMessageProps {
  errorMessage?: string;
  errorTitle?: string;
  errorDescription?: ReactNode;
  error?: IErrorWithSentryId | null | undefined;
  onClickFunction?: () => void;
  buttonMessage?: string;
  noBorder?: boolean;
  imageWidth?: number;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  errorMessage,
  errorTitle,
  errorDescription,
  error,
  onClickFunction,
  buttonMessage,
  noBorder = false,
  imageWidth = 450,
}) => {
  const containerStyle = noBorder ? styles.containerNoBorder : styles.container;
  return (
    <div className={containerStyle}>
      <img src={unhappyFace} alt='carinha triste' width={imageWidth} />
      <p className={styles.textContainer}>
        <div className={styles.title}>{errorTitle ?? 'Erro ao recuperar seus dados.'}</div>
        {errorDescription ??
          'Ocorreu um erro tentando recuperar seus dados. Tente novamente clicando no botão abaixo. Caso o erro persista, favor entrar em contato com o suporte da ANM pelo e-mail gerec@anm.gov.br.'}{' '}
        <br />
        <br />
        {errorMessage && (
          <span className={styles.errorMessage}>
            Mensagem de erro: {errorMessage} {error ? ` ${incluirSentryIdMsgErro(error)}` : ''}
          </span>
        )}
      </p>
      {onClickFunction && (
        <div className={styles.button}>
          <BrButton onClick={onClickFunction} className={styles.button} primary>
            {buttonMessage ?? 'Tentar novamente'}
          </BrButton>
        </div>
      )}
    </div>
  );
};

export default ErrorMessage;
